<template>
    <div>
        <div class="mb-3">
            <a href="back" @click.prevent="goBack" class="link-hover-line text-sm text-default">
                <i class="fa fa-arrow-left mr-1"></i> {{ goBackMessage }}
            </a>
        </div>
        <div>
            
            <div class="search-bar-container mr-3 inline-block" style="width: calc(100% - 106px);">
                <i class="fas fa-search icon"></i>
                <input type="text" placeholder="Search" class="search-bar" v-model="serviceParams.search" @keyup.enter="$refs.list.refresh()">
            </div>
            <button v-if="hasSelectedServices" class="btn btn-warning"  style="height: 43px;" @click="submit">
                Next <i class="fas fa-angle-right ml-2"></i>
            </button>
            <button v-else class="btn btn-warning disabled" disabled style="height: 43px;">
                Next <i class="fas fa-angle-right ml-2"></i>
            </button>
        </div>

        <div class="bg-white shadow-reg list-container">
            <div class="table-navbar"> 
                <a :class="['table-navbar-item', isTypeActive('service') && 'active']" href="services" @click.prevent="setTypeFilter('service')">Services</a>
                <a :class="['table-navbar-item', isTypeActive('package') && 'active']" href="packages" @click.prevent="setTypeFilter('package')">Packages</a>
            </div>
            <div class="list-wrapper">
                <paginated-section v-if="serviceFetchLink && cateredSubcategories.length > 0" :fetch-link="serviceFetchLink" :params="fetchServiceParams" paginate-path="data.result.services" ref="list" simplified>
                    <template slot="loading">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Loading services
                        </h3>
                    </template>
                    <template slot="empty">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">No services were found</h3>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <service-list-item :service="record" @add="addItem" @remove="removeIem" :is-available="isServiceAvailable(record)"/>
                    </template>
                </paginated-section>
            </div>
        </div>

        <service-modal ref="serviceModal" @update="updateService" />

    </div>
</template>
<script>
import '@styles/table.css';
import mixins from "@utils/mixins";
import { bus } from "@utils/bus";
import { get, route } from "@utils/network";
import ServiceModal from "./ServiceModal";
import ServiceListItem from "./ServiceListItem";

export default {
    name: "ServiceSelectionSection",

    components: { ServiceListItem, ServiceModal },

    computed: {
        goBackMessage() {
            return this.viaShop ? "Go back to schedule selection" : "Go back to shop selection";
        },
        hasSelectedServices() {
            return this.services.length > 0 || this.packages.length > 0;
        },
        shop() {
            return this.$store.getters.shop;
        },
        shopParams() {
            const { is_home, datetime } = this.$store.getters.shopSearchParams;
            return { is_home, datetime };
        },
        cateredSubcategoryIds() {
            return this.cateredSubcategories.map(item => item.id);
        },
        fetchServiceParams() {
            return {
                search: this.serviceParams.search,
                type: this.serviceParams.type,
                is_home: this.serviceParams.is_home,
                subcategory_id: this.cateredSubcategoryIds
            }
        },
    },

    data: () => ({
        loading: false,
        serviceFetchLink: null,
        serviceParams: {
            search: "",
            type: "service",
            is_home: 0,
        },
        services: [],
        packages: [],
        cateredSubcategories: [],
    }),

    methods: {
        initialize() {
            this.serviceParams.is_home = this.shopParams.is_home;
            this.serviceFetchLink = route("shops/:id/services-and-packages", { id: this.shop.id });
            this.services = this.$store.getters.services ? [...this.$store.getters.services] : [];
            this.packages = this.$store.getters.packages ? [...this.$store.getters.packages] : [];
            
        },
        goBack() {
            this.$emit("previous");
        },
        setTypeFilter(type) {
            this.serviceParams.type = type;
            this.$nextTick(() => this.$refs.list.refresh());
        },
        isTypeActive(type) {
            return this.serviceParams.type == type;
        },
        addItem(service) {
            const list = service.type == "package" ? "packages" : "services";
            const index = this[list].findIndex(item => item.id == service.id);

            if (index == -1) {
                this[list].push({...service, selectedExperts: []});
                return this.$refs.serviceModal.show(service);
            }

            return this.$refs.serviceModal.show(this[list][index]);

        },
        removeIem(service) {
            const list = service.type == "package" ? "packages" : "services";
            const index = this[list].findIndex(item => item.id == service.id);

            if (index == -1) {
                return
            }
            this[list].splice(index, 1);
        },
        updateService(service) {
            if (service.voucher && this.hasServiceVoucher()) {
                this.clearServiceVouchers();
            }
            const list = service.type == "package" ? "packages" : "services";
            const index = this[list].findIndex(item => item.id == service.id);
            this[list][index] = {...service};
            bus.$emit(`service-updated-${ service.id }`);
        },
        hasServiceVoucher() {
            const hasVoucher = service => service.voucher != undefined || service.voucher != null;
            return this.services.findIndex(hasVoucher) >= 0
                || this.packages.findIndex(hasVoucher) >= 0;
        },
        clearServiceVouchers() {
            const clearVouchers = (service) => {
                service.voucher = null;
                service.voucher_id = null;
                return service;
            }
            this.services.map(clearVouchers);
            this.packages.map(clearVouchers);
        },
        submit() {
            const { packages, services } = this;
            this.$store.dispatch("setServicesAndPackages", { packages, services });
            this.$emit("next");
        },
        fetchShop() {
            get(route("shops/:id", { id: this.shop.id }), { params: this.shopParams })
                .then((response) => {
                    this.cateredSubcategories = response.data.result.shop.cateredSubcategories;
                })
                .catch(error => console.log(error));
        },
        isServiceAvailable(service) {
            if (service.type == "service") {
                return this.cateredSubcategoryIds.findIndex(id => id == service.subcategory_id) > -1
            }

            return service.items.every(item => this.cateredSubcategoryIds.findIndex(id => id == item.subcategory_id) > -1)
        }
    },

    mixins: [mixins],

    props: {
        viaShop: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        this.fetchShop();
    }
}
</script>